import { CloseCircleOutlined, WarningOutlined } from '@ant-design/icons';
import i18next from "i18next";
import {getSessionData} from "../global-util";
import {getOnLineStatusFromNavigator} from "../hooks/useOnlineStatus";


// Standard function to display errors from API calls
// (optional function to format the error message with HTML such <br /> for new lines)
export function showApiError(appAreaTitle, errorObject, appNotificationClass, messageOverrides = [], htmlFormatFunction = null) {

    // Please note:
    // notification gives warning if used directly, must be passed in from calling page
    // that uses App.useApp() to get message, notification or modal classes

    // Get error code and message
    let errorCode = errorObject && errorObject.hasOwnProperty('code') ? errorObject.code : null;
    errorCode = errorCode ? errorCode : 500;
    let errorMessage = errorObject && errorObject.hasOwnProperty('message') ? errorObject.message : null;
    errorMessage = errorMessage ? errorMessage : 'Unknown Error';
    let title = appAreaTitle;
    let noMessage = false;

    // Determine if POST attempt or not
    let isPostAttempt = false;
    const lastMethod = getSessionData('lastFetchMethod');
    if (lastMethod && lastMethod === 'POST') {
        isPostAttempt = true;
    }

    // Log error path
    const lastPath = getSessionData('lastFetchPath');
    if (lastPath && lastMethod) {
        console.error('>> error calling: ' + lastMethod + ' ' + lastPath);
    }

    // Note on 400 or sometimes 409
    // - should have useful message set above as validation errors in the middle tier

    // Standard messages (sometimes may be overridden in next section)
    if (errorCode === 401) { //Unauthorised
        errorMessage = i18next.t('error.std_401');
    }
    else if (errorCode === 403) { //Forbidden
        // Special logout case where some requests may still be in progress and get a 403
        if (getSessionData('loginHash') == null || getSessionData('loginHash') === '') {
            noMessage = true;
        } else {
            errorMessage = i18next.t('error.std_403', {0: i18next.t('title.requested_resource')});
        }
    }
    else if (errorCode === 404) { //Not Found
        errorMessage = i18next.t('error.std_404', {0: i18next.t('title.requested_resource')});
    }

    // Low connectivity/offline handling
    if (   errorMessage.toLowerCase().includes('failed to fetch')
        || errorMessage.toLowerCase().includes('no-response')
        || errorMessage.toLowerCase().includes('load failed') //IOS
        || errorMessage.toLowerCase().includes('timeoutexception')
        || errorMessage.toLowerCase().includes('hostexception')
        || errorMessage.toLowerCase().includes('sslexception')
        || errorCode === 502    //Bad Gateway
        || errorCode === 504 )  //Gateway Timeout
    {
        if (getOnLineStatusFromNavigator()) {
            // Online (these errors likely due to low connectivity)
            console.error(errorCode + '/499 low connectivity error - area: ' + (appAreaTitle ? appAreaTitle : ''))
            errorMessage = i18next.t('error.unable_connect');

        } else {
            // Offline (should be coded for by limiting menu/tab bar icon/action button or caching at login, but in case)
            console.error(errorCode + '/499 offline error (check system code to prevent or cache at login) - area: ' + (appAreaTitle ? appAreaTitle : ''))
            errorMessage = i18next.t( isPostAttempt ? 'error.online_only' : 'error.offline' );
        }
        title = null;
        if (errorCode > 499) {
            errorCode = 499;
        }
    }

    // Message overrides (if passed in)
    if (messageOverrides && messageOverrides.length > 0) {
       messageOverrides.forEach(item => {
           if (item.status === errorCode) {
               errorMessage = item.message;
               noMessage = false; //override no message flag (like for 403 above) when override set (like on login 403)
           }
       })
    }

    // HTML formatting of message if function provided
    if (htmlFormatFunction) {
        errorMessage = htmlFormatFunction(errorMessage);
    }

    // Show as warning or error
    if (noMessage) {
        // No error message
        console.error(errorCode + ' error (not giving message) - area: ' + (appAreaTitle ? appAreaTitle : ''));
        console.error(errorObject);
    } else if (errorCode >= 400 && errorCode < 500) {
        // Show validation message
        if (errorCode !== 499) {
            console.error(errorCode + ' validation error - area: ' + (appAreaTitle ? appAreaTitle : ''));
        }
        console.error(errorObject);
        appNotificationClass.destroy();
        appNotificationClass.open({
            icon: <WarningOutlined style={{color: 'var(--dp-status-colour-warning)'}}/>,
            message: title,
            description: htmlFormatFunction ? (<p dangerouslySetInnerHTML={{ __html: errorMessage }}></p>) : errorMessage,
            duration: null,
        });
    } else {
        // Show error message
        console.error(errorCode + ' server error - area: ' + (appAreaTitle ? appAreaTitle : ''));
        console.error(errorObject);
        appNotificationClass.destroy();
        appNotificationClass.open({
            icon: <CloseCircleOutlined style={{color: 'var(--dp-status-colour-danger)'}}/>,
            message: title ? title + ' Error' : null,
            description: htmlFormatFunction ? (<p dangerouslySetInnerHTML={{ __html: errorMessage }}></p>) : errorMessage,
            duration: null,
        });
    }
}
